import type { Channel, Partner } from "@expert/shared-types";

import { getAppConfigSingleton } from "@expert/app-config";

import { type AllowedPartners, BlockedChannels, EnabledPartners } from "../types";

/**
 * Determines if Expert University is enabled for a partner on a given channel.
 * @param value Partner value (e.g., "verizon")
 * @param channel - Critical: some channels (e.g., "chat") may not support Expert University yet,
 *                  so a partner may be enabled in config, but really is unavailable if the channel is blocked.
 */
export function partnerEnabledForExpertUniversity(value: string, channel: Channel): value is AllowedPartners {
    const isChannelBlocked = BlockedChannels.includes(channel);
    return !isChannelBlocked && EnabledPartners.includes(value as AllowedPartners);
}

export function getFeatureOverrides(partner: Partner) {
    return getAppConfigSingleton().getPartnersConfig(partner).features;
}
